<script setup>
  import { ref, onMounted, watch } from 'vue';

  import useLegacyBridge from "@/composables/useLegacyBridge";
  import { useUpdateKey } from '@/composables/useUpdateKey';

  const content = defineModel('content');

  const props = defineProps({
    spotId: {
      type: Number,
      required: true
    }
  });

  const { stats } = useLegacyBridge();
  const updateKey = useUpdateKey();

  const contentContainer = ref(null);
  
  function loadStats() {
    const settings = {
      spotId: props.spotId,
    }       
    
    content.value = stats(contentContainer.value, settings);
  }

  onMounted(() => props.spotId && loadStats());

  watch(updateKey.key, () => content.value.refresh())
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>